import React from 'react';
import { Text, TextProps } from '@ui-kitten/components';
import { StyleProp, TextStyle } from 'react-native';

export interface BrandTextProps extends TextProps {
    style?: StyleProp<TextStyle>;
}

export function BrandText(props: BrandTextProps) {
    return (
        <Text {...props} style={[ props.style, { fontFamily: 'fascinate-inline' } ]} />
    );
}
